
import { CreateBooking } from '@/models/bookings';
import { BookingTimeDisplay, CREATE_BOOKING_DATE_FORMAT } from '@/utils/constants';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class BookingTime extends Vue {
  @Prop({ required: true }) readonly booking: CreateBooking;
  @Prop({ default: BookingTimeDisplay.START }) readonly time_display: BookingTimeDisplay;

  readonly BookingTimeDisplay = BookingTimeDisplay;
  readonly date_missing = this.$t('bookings.labels.choose_date');

  get showStartTime(): string {
    const time = this.getStartTime;
    return time || this.date_missing;
  }

  get getStartTime(): string {
    if (!this.booking.startDate && !this.booking.startTime) return '';
    const time = this.booking.startTime ? ` ${moment(this.booking.startTime, 'HH:mm').format('HH:mm')}` : '';
    return `${this.booking.startDate}${time}`;
  }

  get activeStartTime(): boolean {
    return (
      this.time_display === BookingTimeDisplay.START ||
      (this.time_display === BookingTimeDisplay.BOTH &&
        (!this.booking.startDate ||
          !this.booking.startTime ||
          moment().isBefore(moment(this.getStartTime, `${CREATE_BOOKING_DATE_FORMAT} HH:mm`))))
    );
  }

  get showEndTime(): string {
    const time = this.getEndTime;
    return time || this.date_missing;
  }

  get getEndTime(): string {
    if (!this.booking.endDate && !this.booking.endTime) return '';
    const time = this.booking.endTime ? ` ${moment(this.booking.endTime, 'HH:mm').format('HH:mm')}` : '';
    return `${this.booking.endDate}${time}`;
  }

  get activeEndTime(): boolean {
    return (
      this.time_display === BookingTimeDisplay.END ||
      (this.time_display === BookingTimeDisplay.BOTH &&
        (!this.getEndTime || moment().isBefore(moment(this.getEndTime, `${CREATE_BOOKING_DATE_FORMAT} HH:mm`))))
    );
  }

  onStartDateClicked(): void {
    this.$router.push('/booking/start-date');
  }

  onEndDateClicked(): void {
    if (this.booking.endDate) {
      this.$router.push('/booking/end-date');
    }
  }
}
